<template>
    <div class="ld-container">
        <AnalysisPage />
    </div>
</template>

<script>
import AnalysisPage from "./components/analysis/AnalysisPage.vue";
export default {
    components: {
        AnalysisPage,
    },
};
</script>

<!-- 디자인 토큰은 b-modal 포털(body 직하)까지 닿아야 하므로 scoped 밖에서 로드한다 -->
<style>
@import "./styles/tokens.css";
</style>

<style scoped>
.ld-container {
    height: 91vh;
    width: 100%;
    box-sizing: border-box;
    /* 90vh 고정 높이라 상하 패딩은 그대로 내부 오버플로가 된다. 여백은 좌우만 준다. */
    /* padding: 0 12px;
    background: var(--ebc-bg);
    border-radius: var(--ebc-radius-md); */
    overflow: hidden;
}
</style>
